import { z } from 'zod';

const isValidEmail = (email: unknown) =>
  z.string().email().safeParse(email).success;

/**
 * One row of the family invite form. Unlike the email-only invite this asks for
 * a phone number up front, so an accepted member can receive text reminders
 * without the owner having to go back through the roster to add one — the dead
 * end behind AH-2426.
 *
 * The number is only checked for presence here; whether it's a real number is
 * intl-tel-input's call at submit time, and the E.164 value comes from there too.
 */
export const FamilyAddMembersSchema = z.object({
  invitees: z
    .array(
      z.object({
        name: z.string().trim().min(1, { message: 'Name is required' }),
        email: z
          .string()
          .trim()
          .min(1, { message: 'Email address is required' })
          .refine(isValidEmail, {
            message: 'Enter a valid email address',
          }),
        phoneNumber: z
          .string()
          .trim()
          .min(1, { message: 'Phone number is required' }),
      })
    )
    .min(1),
  authorized: z.boolean().refine((value) => value, {
    message: 'Confirm you are authorized to text these numbers',
  }),
});

export type FamilyAddMembersDto = z.infer<typeof FamilyAddMembersSchema>;
